import {
  PRICE_COMPONENT_LABEL,
  PRICE_COMPONENT_PRODUCT_NAME,
  PriceComponentType,
} from '../../Enums/price-component-type.enum';
import { LicenceComponentResponse } from '../../Interfaces/api/backoffice/licence.interface';

export class LicenceComponent {
  component_type = '';
  purchased = 0;
  assigned = 0;
  free = 0;
  half_state = 0;
  pending_cancellation = 0;
  cancellable = 0;
  is_available = false;
  stripe_quantity: number | null = null;
  is_in_sync: boolean | null = null;
  unit_amount: number | null = null;
  currency: string | null = null;

  constructor(data: Partial<LicenceComponentResponse> = {}) {
    Object.assign(this, data);
  }

  get componentLabelKey(): string {
    return PRICE_COMPONENT_LABEL[this.component_type as PriceComponentType] ?? this.component_type;
  }

  get stripeProductNameKey(): string {
    return (
      PRICE_COMPONENT_PRODUCT_NAME[this.component_type as PriceComponentType] ?? this.component_type
    );
  }

  get isAgent(): boolean {
    return this.component_type === PriceComponentType.AGENT;
  }

  get isDrifted(): boolean {
    return this.is_in_sync === false;
  }

  get hasPendingCancellation(): boolean {
    return this.pending_cancellation > 0;
  }
}
